import { startBgm, stopAllBgm, stopBgm } from "./bgmPlayers.js";
import { BGM_TRACKS, type GameBgmId } from "./bgmTracks.js";

export type BgmCatalogItem = {
  id: GameBgmId;
  name: string;
  description: string;
  start: () => Promise<boolean>;
  stop: () => void;
};

export const BGM_CATALOG: readonly BgmCatalogItem[] = BGM_TRACKS.map((track) => ({
  id: track.id,
  name: track.name,
  description: track.description,
  start: () => startBgm(track.id),
  stop: () => stopBgm(track.id),
}));

export function stopAllCatalogBgm(): void {
  stopAllBgm();
}
